<template>
  <div>
    <div v-for="(typeGroup, typeIndex) in typeGroups" :key="typeIndex" class="activity-type-block">
      <div class="activity-type-header">{{ typeGroup.activityAuditTypeName }}</div>
      <v-client-table :key="'activityAuditGrid-' + typeIndex" class="hiaTable" :ref="'activityAuditGrid' + typeIndex" :id="'activityAuditGrid' + typeIndex" :data="typeGroup.rows" :columns="columns" :options="options" uniqueKey="activityAuditRecordId"> </v-client-table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'coderActivityAudits',
    props: {
      activityAudits: {
        type: Array,
        default: function () {
          return []
        }
      },
      showCodeType: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      typeGroups() {
        const arr = this.activityAudits || []
        const typeNames = [...new Set(arr.map((x) => x.activityAuditTypeName))].sort()
        return typeNames.map((name) => ({
          activityAuditTypeName: name,
          rows: this.mapGridRows(arr.filter((x) => x.activityAuditTypeName === name))
        }))
      },
      columns() {
        if (this.showCodeType) {
          return ['codeTypeDisplay', 'activityName', 'handledDisplay', 'notesDisplay', 'reasonDisplay']
        }
        return ['activityName', 'handledDisplay', 'notesDisplay', 'reasonDisplay']
      },
      options() {
        const columnsClasses = {
          activityName: 'activityNameCol',
          handledDisplay: 'handledCol',
          notesDisplay: 'notesCol',
          reasonDisplay: 'reasonCol'
        }
        const headings = {
          activityName: 'Activity',
          handledDisplay: 'Handled Correctly',
          notesDisplay: 'Notes',
          reasonDisplay: 'Reason'
        }

        if (this.showCodeType) {
          columnsClasses.codeTypeDisplay = 'codeTypeCol'
          headings.codeTypeDisplay = 'Code Type'
        }

        return {
          filterable: false,
          filterByColumn: false,
          resizableColumns: false,
          queue: [],
          networkFunction: null,
          perPage: 100,
          columnsClasses,
          headings
        }
      }
    },
    methods: {
      mapGridRows(rows) {
        return [...rows]
          .sort((a, b) => {
            if (this.showCodeType) {
              const codeCompare = (a.codeType || '').localeCompare(b.codeType || '')
              if (codeCompare !== 0) return codeCompare
            }
            return (a.activityName || '').localeCompare(b.activityName || '')
          })
          .map((row) => ({
            ...row,
            codeTypeDisplay: row.codeType || '-',
            handledDisplay: this.formatHandled(row),
            notesDisplay: row.notes || '',
            reasonDisplay: row.reasonForChange || ''
          }))
      },
      formatHandled(row) {
        if (row.handledCorrectly === true) {
          return 'Yes'
        }
        if (row.handledCorrectly === false) {
          return row.exclude ? 'No (Excluded)' : 'No'
        }
        return '-'
      }
    }
  }
</script>

<style scoped>
  .activity-type-block {
    margin-bottom: 16px;
  }

  .activity-type-block:last-child {
    margin-bottom: 0;
  }

  .activity-type-header {
    background-color: #fafafa;
    text-align: center;
    padding: 5px;
    font-size: 13px;
    font-weight: 600;
    color: #606266;
  }

  >>> .activityNameCol {
    min-width: 20%;
  }

  >>> .handledCol {
    min-width: 12%;
  }

  >>> .notesCol {
    min-width: 30%;
  }

  >>> .reasonCol {
    min-width: 15%;
  }

  >>> .codeTypeCol {
    min-width: 12%;
  }

  >>> td {
    font-size: 13px !important;
  }
</style>
